import React, { useContext, useEffect, useState } from 'react'
import { IonCard, IonRow, IonCol, IonItemDivider, isPlatform } from '@ionic/react'
import { ConfigContext } from '../contexts/ConfigContext'

const AccountSummary = () => {
    const {  getStocksValue, getSalesAmount, getLedgerValues, getPurchaseAmount  } = useContext(ConfigContext)
    const [stocksValue, setStockValue] = useState(0);
    const [saleAmt, setSaleAmt] = useState(0);
    const [purchaseAmt, setPurchaseAmt] = useState(0);
    const [CashinHand, setCashinHand] = useState(0);
    const [receivable, setReceivable] = useState(0);
    const [payable, setPayable] = useState(0);
    useEffect(() => {
        getStocksValue().then(res => {
            setStockValue(res)
        })
        getSalesAmount().then(res => {
            setSaleAmt(res)
        })
        getPurchaseAmount().then(res => {
            setPurchaseAmt(res)
        })
        getLedgerValues().then(res => {
            setReceivable(res.receivable)
            setPayable(res.payable)
            setCashinHand(res.cashinHand)
        })
    }, [getLedgerValues, getPurchaseAmount, getSalesAmount, getStocksValue])

    const asset = CashinHand + stocksValue + receivable;
    const libelity = payable;
    const equity = asset - libelity;


    return (
        <IonCard class='ion-padding' id='balanceSheet'>
            <h4 className='black-text center'>Account Summary</h4>
            <p>Sales  : &#8377; {parseFloat(saleAmt).toFixed(2)}</p>
            <p>Purchase  : &#8377; {parseFloat(purchaseAmt).toFixed(2)}</p>

            {isPlatform("mobile") ? (
                <>
                    <h5>Libelity & Owner Equity</h5>
                    <p>Payables : &#8377; {parseFloat(payable).toFixed(2)}</p>
                    <h6>Total Libelity : &#8377; {parseFloat(libelity).toFixed(2)}</h6>
                    <h6>Total Equity (Value) : &#8377; {parseFloat(equity).toFixed(2)}</h6>
                    <h5>Assets (current)</h5>
                    <p>Cash in Hand : &#8377; {parseFloat(CashinHand).toFixed(2)}</p>
                    <p>Stocks in Value : &#8377; {parseFloat(stocksValue).toFixed(2)}</p>
                    <p>Receivables : &#8377; {parseFloat(receivable).toFixed(2)}</p>
                </>
            ) : (
                <>
                    <IonRow>
                        <IonCol size='6'>
                            <h5>Assets (current)</h5>
                            <p>Cash in Hand : &#8377; {parseFloat(CashinHand).toFixed(2)}</p>
                            <p>Stocks in Value : &#8377; {parseFloat(stocksValue).toFixed(2)}</p>
                            <p>Receivables : &#8377; {parseFloat(receivable).toFixed(2)}</p>
                        </IonCol>
                        <IonCol size='6'>
                            <h5>Libelity & Owner Equity</h5>
                            <p>Payables : &#8377; {parseFloat(payable).toFixed(2)}</p>
                            <p>Total Libelity : &#8377; {parseFloat(libelity).toFixed(2)}</p>
                            <p>Total Equity (Value) : &#8377; {parseFloat(equity).toFixed(2)}</p>
                        </IonCol>
                    </IonRow>
                    <IonItemDivider />
                    <IonRow>
                        <IonCol>
                            <h6>Total  : &#8377; {parseFloat(asset).toFixed(2)}</h6>
                        </IonCol>
                        <IonCol>
                            <h6>Total  : &#8377; {parseFloat(libelity + equity).toFixed(2)}</h6>
                        </IonCol>
                    </IonRow>
                </>
            )}
        </IonCard>
    )
}

export default AccountSummary
